export const VARIANT_SIMPLE = 'simple'
export const VARIANTS = [VARIANT_SIMPLE]
